<template>
  <div class="launchpack-delivery">
    <!-- 교환 배송 대기 -->
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="조회"
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveInvoice">송장번호 저장</button>
    </div>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @check="clickCheckBox"
                 :table_width="1800"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </td>

      <!-- 번호 -->
      <td slot="index" slot-scope="props">{{ props.item.index }}</td>

      <!-- 상품 주문번호 -->
      <td slot="id" slot-scope="props">
        <div @click="clickDetail(`${props.item.order.id}&page=OrderListExchangeDeliveryNew`)" class="unselect" style="text-decoration:underline">{{ props.item.id }}</div>
      </td>

      <!-- 날짜 -->
      <td slot="created_time" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.created_time }}</td>

      <!-- 주문자 -->
      <td slot="order" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.name }}</td>

      <!-- 주문 상품 -->
      <td slot="product" slot-scope="props">
        <div class="flex align-center">
          <img :src="props.item.product.img" style="width:35px;height:35px;margin-right:6px" v-if="props.item.product.img">
          <div style="text-align: left">
            <div v-if="props.item.order_product_option.length>0">
              <div>{{ props.item.product.name }}</div>
              <div
                v-for="(option, option_idx) in props.item.order_product_option"
                :key="'option-'+option_idx">
                <span v-if="option.option.option_type===0">기본옵션:</span>
                <span v-if="option.option.option_type===1">추가옵션:</span>
                {{ optionFullName(option) }}
              </div>
            </div>
            <div v-else>
              {{ props.item.product.name }}
            </div>
          </div>
        </div>
      </td>

      <!-- 수량 -->
      <td slot="quantity" slot-scope="props">{{ props.item.quantity }}</td>

      <!-- 총 상품 금액-->
      <td slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</td>

      <!-- 배송 금액 -->
      <td slot="delivery_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.delivery_cost | currency }}</td>

      <!-- 할인 금액 -->
      <td slot="discount_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.discount_price | currency }}</td>

      <!-- 전체 금액-->
      <td slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="props.item.rowspan>0">{{ props.item.order.total_price | currency }}</td>

      <!-- 파트너명 -->
      <td slot="partner" slot-scope="props">
        <div v-if="props.item.partner">{{ props.item.partner }}</div>
        <div v-else>-</div>
      </td>

      <!-- 상태 변경 -->
      <td slot="status_change" slot-scope="props">
        <button class="button" @click="clickSingleChange(props.item.id,607)">배송중 처리</button>
      </td>

      <!-- 택배사 -->
      <td slot="delivery_company" slot-scope="props">
        <span class="select">
          <select v-model="props.item.delivery_company"
                  @change="e=> selectDeliveryCompany(e, props.item)">
            <option value="" disabled selected>선택</option>
            <option :value="item.value"
                    v-for="item in deliveryArr" :key="item.label">{{ item.label }}</option>
          </select>
        </span>
      </td>

      <!-- 송장번호 -->
      <td slot="invoice" slot-scope="props">
        <input class="input"
               :value="props.item.invoice"
               @input="e => props.item.invoice = e.target.value"
               @keyup.enter="saveSingleInvoice(props.item)"
               placeholder="송장번호 입력"
               type="number">
      </td>

      <!-- 주문 상태 -->
      <td slot="status_kor" slot-scope="props">{{ props.item.status_kor }}</td>

      <!-- 결제 방법 -->
      <td slot="pay_type" slot-scope="props"><span>{{ props.item.pay_type }}</span></td>

      <!-- 교환 사유 -->
      <td slot="reason" slot-scope="props">{{ props.item.reason }}</td>

      <!-- 일괄 처리 -->
      <div slot="spot" v-if="status_arr.length>0">
        <div class="flex align-center" style="background-color: #eee; padding: 8px">
          <span>선택한 주문을</span>
          <span class="select" style="margin-left: 8px">
            <select v-model="status" @change="e => status=e.target.value">
              <option value="" disabled selected>주문상태</option>
              <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
            </select>
          </span>
          <button class="button" style="margin-left:8px"
                  @click="clickChange">일괄처리</button>
        </div>
      </div>
    </order-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="결제 취소 처리" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <modal name="exchangeDeliverModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="교환 배송중 처리" :useTab="false" class="lp-modal-wrapper">
        <div>교환 배송중 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('exchangeDeliverModal')">취소</button>
          <button class="button is-primary" @click="clickDeliver">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import DeliveryMixin from "@/mixins/DeliveryMixin"

  export default {
    name: 'OrderListExchangeDeliveryNew',
    components: {LpCheckBool},
    mixins: [
      DeliveryMixin
    ],
    data() {
      return {
        // 배송업체 목록
        deliveryArr: []
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // (테이블 필드, 사용할 api, 현재페이지)
        this.initializing('exchange_delivery_new', 'delivery/orderproduct?status=606', 'OrderListExchangeDeliveryNew');
        this.getDeliveryCompany();
      },
      clickDeliver() {
        if(this.optionState === 'btn') {
          this.statusChange(this.selectedSingleItem,607,'exchangeDeliverModal')
        }
        else {
          this.confirmModal('exchangeDeliverModal')
        }
      },
      getDataFromServer() {
        this.getData();
      },
      getDeliveryCompany() {
        this.$axios.get('public/delivery/delivery_company').then(res=> {
          this.deliveryArr = res.data;
        })
      },
      selectDeliveryCompany(e, item) {
        item.delivery_company = e.target.value;
        this.$axios.post(this.getUrl(`delivery/orderproduct/${item.id}/invoice/update`), {
          invoice: item.invoice,
          delivery_company: item.delivery_company
        }).then(()=> {})
      },
      saveSingleInvoice(item) {
        console.log(item.invoice)
        this.$axios.post(this.getUrl(`delivery/orderproduct/${item.id}/invoice/update`), {
          invoice: item.invoice,
          delivery_company: item.delivery_company
        }).then(()=> {})
      },
      saveInvoice() {
        let check_list = this.getCheckedArr();
        if(check_list.length===0) {
          this.toast('송장번호를 입력했다면, 체크박스를 선택해주세요.');
          return;
        }
        let params = []
        this.tableItems.forEach(item=> {
          if(check_list.indexOf(item.id)>-1) {
            params.push({id: item.id, delivery_company: item.delivery_company, invoice: parseInt(item.invoice)})
          }
        })
        this.$axios.post(this.getUrl('delivery/orderproduct/invoice/update'), {
          params: params
        }).then(res=>{
          if(res.status===200) {
            this.toast('송장번호가 저장되었습니다.')
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .launchpack-delivery td
    border 1px solid #dbdbdb
</style>
